import {
    CustomerOfficeActionTypes,
    FETCH_CUSTOMER_OFFICE_BY_ID,
    FETCH_CUSTOMER_OFFICE_BY_ID_ERROR,
    FETCH_CUSTOMER_OFFICE_BY_ID_SUCCESS,
    FETCH_CUSTOMER_OFFICES,
    FETCH_CUSTOMER_OFFICES_ERROR,
    FETCH_CUSTOMER_OFFICES_SUCCESS,
    CREATE_CUSTOMER_OFFICE, CREATE_CUSTOMER_OFFICE_ERROR, CREATE_CUSTOMER_OFFICE_SUCCESS,
    DELETE_CUSTOMER_OFFICE, DELETE_CUSTOMER_OFFICE_ERROR, DELETE_CUSTOMER_OFFICE_SUCCESS,
    RESTORE_CUSTOMER_OFFICE, RESTORE_CUSTOMER_OFFICE_ERROR, RESTORE_CUSTOMER_OFFICE_SUCCESS,
    UPDATE_CUSTOMER_OFFICE, UPDATE_CUSTOMER_OFFICE_ERROR, UPDATE_CUSTOMER_OFFICE_SUCCESS
} from "../../actions/customers/CustomerOfficeActions";
import {BasicReducerState} from "../BasicReducerState";
import {CustomerOffice} from "../../models/customers/CustomerOffice";
import {Nullable} from "../../models/common/Nullable";
import {
    errorFetchingRequestState,
    startFetchingRequestState,
    successFetchingRequestState
} from "../../models/common/RequestState";


export interface CustomerOfficeState {
    [ key: number ]: BasicReducerState< Nullable< CustomerOffice[] >, Nullable< CustomerOffice >>
}

export function CustomerOfficeReducer(
    state: CustomerOfficeState = {},
    action: CustomerOfficeActionTypes
) {

    switch( action.type ) {
        case FETCH_CUSTOMER_OFFICES:
            return {
                ...state,
                [ action.customerId.rawValue ]: {
                    ...( state[ action.customerId.rawValue ] ?? {} ),
                    totalEntries: 0,
                    entries: {
                        ...( state[ action.customerId.rawValue ]?.entries ?? { current: null } ),
                        request: startFetchingRequestState()
                    }
                }
            };
        case FETCH_CUSTOMER_OFFICES_SUCCESS:
            return {
                ...state,
                [ action.customerId.rawValue ]: {
                    ...state[ action.customerId.rawValue ] ?? {},
                    totalEntries: action.payload.totalEntries,
                    entries: {
                        current: action.payload.entries,
                        request: successFetchingRequestState()
                    }
                }
            };
        case FETCH_CUSTOMER_OFFICES_ERROR:
            return {
                ...state,
                [ action.customerId.rawValue ]: {
                    ...state[ action.customerId.rawValue ] ?? {},
                    entries: {
                        ...state[ action.customerId.rawValue ].entries ?? {},
                        request: errorFetchingRequestState( action.error )
                    }
                }
            };
        case FETCH_CUSTOMER_OFFICE_BY_ID:
            return {
                ...state,
                [ action.customerId.rawValue ]: {
                    ...state[ action.customerId.rawValue ] ?? {},
                    detailedEntries: {
                        ...state[ action.customerId.rawValue ].detailedEntries ?? {},
                        [ action.officeId.rawValue ]: {
                            entry: null,
                            request: startFetchingRequestState()
                        }
                    }
                }
            };
        case FETCH_CUSTOMER_OFFICE_BY_ID_SUCCESS:
            return {
                ...state,
                [ action.customerOffice.customerId.rawValue ]: {
                    ...state[ action.customerOffice.customerId.rawValue ] ?? {},
                    detailedEntries: {
                        ...state[ action.customerOffice.customerId.rawValue ].detailedEntries ?? {},
                        [ action.customerOffice.officeId.rawValue ]: {
                            entry: action.customerOffice,
                            request: successFetchingRequestState()
                        }
                    }
                }
            };
        case FETCH_CUSTOMER_OFFICE_BY_ID_ERROR:
            return {
                ...state,
                [ action.customerId.rawValue ]: {
                    ...state[ action.customerId.rawValue ] ?? {},
                    detailedEntries: {
                        ...state[ action.customerId.rawValue ].detailedEntries ?? {},
                        [ action.officeId.rawValue ]: {
                            entry: null,
                            request: errorFetchingRequestState( action.error )
                        }
                    }
                }
            };
        case CREATE_CUSTOMER_OFFICE:
        case UPDATE_CUSTOMER_OFFICE:
        case DELETE_CUSTOMER_OFFICE:
        case RESTORE_CUSTOMER_OFFICE:
            return {
                ...state,
                [ action.customerId.rawValue ]: {
                    ...state[ action.customerId.rawValue ] ?? {},
                    changingRequest: startFetchingRequestState()
                }
            };
        case CREATE_CUSTOMER_OFFICE_SUCCESS:
        case UPDATE_CUSTOMER_OFFICE_SUCCESS:
        case DELETE_CUSTOMER_OFFICE_SUCCESS:
        case RESTORE_CUSTOMER_OFFICE_SUCCESS:
            return {
                ...state,
                [ action.customerId.rawValue ]: {
                    ...state[ action.customerId.rawValue ] ?? {},
                    changingRequest: successFetchingRequestState()
                }
            };
        case CREATE_CUSTOMER_OFFICE_ERROR:
        case UPDATE_CUSTOMER_OFFICE_ERROR:
        case DELETE_CUSTOMER_OFFICE_ERROR:
        case RESTORE_CUSTOMER_OFFICE_ERROR:
            return {
                ...state,
                [ action.customerId.rawValue ]: {
                    ...state[ action.customerId.rawValue ] ?? {},
                    changingRequest: errorFetchingRequestState( action.error )
                }
            };
        default:
            return state;
    }

}